<script>
  import FeedItemDetails from '@/components/Feed/FeedItemDetails.vue'
  import ChildAvatar from '@/components/Child/ChildAvatar.vue'

  export default {
    props: {
      item: {
        required: true,
        type: Object
      }
    },

    components: {
      FeedItemDetails,
      ChildAvatar
    }
  }
</script>
